<template>
  <div class="p-3">
    <div class="flex justify-center mb-4">
      <div class="custom-emoji-icon rounded-full p-4">
        <span class="text-2xl">🤑</span>
      </div>
    </div>
    <p class="text-white mb-2" style="font-size: 18px; line-height: 21.78px; text-align: center;">Insira abaixo o telefone vinculado a conta da Hypezbet</p>
    <p class="text-gray-400 mb-6 text-xs">Faça login para desbloquear os seus ganhos</p>
    <input v-model="phone" @input="cleanPhone" type="text" placeholder="11 9 5721 8700" class="w-full p-2 mb-4 rounded custom-input focus:outline-none focus:ring-2 focus:ring-blue-500">
    <button @click="proceed" :disabled="loading" class="custom-button w-full h-[40px] py-2 rounded hover:bg-blue-600">
      <span v-if="!loading">Acessar conta</span>
      <span v-else class="loader"></span>
      <svg v-if="!loading" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-2">
        <path d="M3.15004 11.6667L2.33337 10.85L9.10004 4.08335H5.25004V2.91669H11.0834V8.75002H9.91671V4.90002L3.15004 11.6667Z" fill="white" />
      </svg>
    </button>
    <div class="flex justify-center mt-4">
      <div class="page-indicator page-indicator-active"></div>
      <div class="page-indicator page-indicator-inactive"></div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import api from '@/services/api';
import { criarGate, normalizarTelefone, ORIGEM, LIMIAR_PADRAO } from '@/services/gateVitalicio';

export default {
  name: 'ScreenOne',
  props: ['referral'],
  data() {
    return {
      loading: false,
      phone: '',
      threashold: LIMIAR_PADRAO
    };
  },
  methods: {
    cleanPhone() {
      this.phone = this.phone.replace(/\D/g, '');
    },
    async setLifetimeAccess() {
      try{
        const phone = this.phone;
        let res = await api.post('/dashboard/api/lifetime-activation/', { phone: phone });
        console.log('setLifetimeAccess', res.data);
        return res.data;
      }catch(e){
        console.log('setLifetimeAccess', e);
        return { error: e.message }
      }
    },

    // O gate saiu daqui na F2 (plano-firebase-para-aws.md:2.1). Esta tela agora
    // so' pergunta e navega; quem le RTDB ou API e' services/gateVitalicio.js,
    // escolhido por VUE_APP_GATE (rtdb|sombra|api).
    async proceed() {
      if (!this.phone) {
        return;
      }
      this.loading = true;
      try {
        const gate = await criarGate();
        const resultado = await gate.avaliar(this.phone, this.referral);
        this.threashold = resultado.limiar;
        this.avisarTotalDeHoje(resultado);
        await this.entrarOuPedirDeposito(gate, resultado);
      } catch (error) {
        alert('Erro ao obter informações de depósito: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    // Mesma condicao de antes: o ramo da flag nunca lia `/data`, entao nao tem
    // total de hoje para mostrar na tela de deposito faltante.
    avisarTotalDeHoje(resultado) {
      if (resultado.origem !== ORIGEM.FLAG) {
        this.$emit('update-today-total', resultado.totalHoje);
      }
    },

    async entrarOuPedirDeposito(gate, resultado) {
      if (!resultado.vitalicio) {
        this.$emit('missing-deposit');
        return;
      }
      // Grava a flag so no ramo `deposito_hoje`, como o `set()` de ScreenOne.vue:117-118
      // fazia: quem entra por `deposito_qualquer_dia` segue sem flag.
      if (resultado.origem === ORIGEM.DEPOSITO_HOJE) {
        await gate.conceder(this.phone, this.referral);
      }
      Cookies.set('phone', normalizarTelefone(this.phone));
      await this.setLifetimeAccess();
      this.$emit('next-screen');
    }
  },
  mounted() {
    if (Cookies.get('phone')) {
      this.$emit('next-screen');
    }
  }
};
</script>

<style scoped>
.text-white {
  font-size: 18px;
  line-height: 21.78px;
  text-align: center;
}

.custom-emoji-icon {
  background-color: #1e39a3;
}

.custom-input {
  background-color: #ffffff;
  color: #666666;
  border: 1px solid #cccccc;
  height: 44px;
}

.custom-button {
  background-color: #2555FF;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-button:disabled {
  background-color: #cccccc;
}

.loader {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #2555FF; /* Blue */
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.page-indicator {
  width: 77px;
  height: 5px;
  border-radius: 2.5px;
  margin: 0 5px;
}

.page-indicator-active {
  background-color: #2547C0;
}

.page-indicator-inactive {
  background-color: #D4D9E82E;
}
</style>
